import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const OrderSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default OrderSVG;
